import { Icon } from '@iconify/react';
import cx from 'classnames';

export default function CheckList({ items, iconColor, className }) {
  return (
    <ul className={cx('pl-0', className)}>
      {items.map((item, i) => {
        if (typeof item !== 'string') {
          if (typeof item == 'object' && item?.sublist != 'undefined' && !item?.sublist) {
            return (
              <li key={i} className="flex gap-2">
                <Icon
                  className={cx('shrink-0', iconColor ? iconColor : 'text-primary-500')}
                  height="24"
                  icon="fluent:checkmark-circle-16-regular"
                />
                {item.item}
              </li>
            );
          } else if (item?.sublist) {
            return (
              <li key={i} className="block">
                <div className="flex gap-2">
                  <Icon
                    className={cx('shrink-0', iconColor ? iconColor : 'text-primary-500')}
                    height="24"
                    icon="fluent:checkmark-circle-16-regular"
                  />
                  {item.item}
                </div>
                <ul>
                  {item.sublist.map((item, i) => (
                    <li key={i}>{item.item}</li>
                  ))}
                </ul>
              </li>
            );
          }
        }

        return (
          <li key={i} className="flex gap-2">
            <Icon
              className={cx('shrink-0', iconColor ? iconColor : 'text-primary-500')}
              height="24"
              icon="fluent:checkmark-circle-16-regular"
            />
            {item}
          </li>
        );
      })}
    </ul>
  );
}
